import React from 'react';
import { Sparkles, HelpCircle } from 'lucide-react';

const PujaAreaStep = ({ pujaArea, pujaLocation, onPujaChange, onLocationChange }) => {
  const pujaOptions = [
    { id: 'separate-room', label: 'Yes, separate room' },
    { id: 'corner', label: 'Yes, a corner in a room' },
    { id: 'no-area', label: 'No dedicated area' },
    { id: 'unsure', label: 'Not sure / No idea' }
  ];

  const gridDirections = [
    ['NW', 'N', 'NE'],
    ['W', 'Center', 'E'],
    ['SW', 'S', 'SE']
  ];

  const showLocationGrid = pujaArea === 'separate-room' || pujaArea === 'corner';

  return (
    <div>
      <h3 className="text-2xl font-bold text-[#232323] mb-2">Do you have a puja or prayer area?</h3>
      <p className="text-[#353535] mb-6">Select the option that best describes your prayer space.</p>
      
      {/* Puja area options */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        {pujaOptions.map((option) => {
          const isSelected = pujaArea === option.id;
          
          return (
            <button
              key={option.id}
              onClick={() => onPujaChange(option.id)}
              className={`p-4 border-2 rounded-xl text-left transition-all hover:shadow-md ${
                isSelected
                  ? 'border-[#232323] bg-[var(--accent-saffron)]'
                  : 'border-gray-200 hover:border-[#999999]'
              }`}
            >
              <div className="flex items-center gap-3">
                <Sparkles className="w-5 h-5 text-[#232323]" />
                <span className="font-semibold text-[#232323]">{option.label}</span>
              </div>
            </button>
          );
        })}
      </div>

      {/* Location grid (conditional) */}
      {showLocationGrid && (
        <div>
          <h4 className="text-lg font-bold text-[#232323] mb-3">Where is it located?</h4>
          <p className="text-sm text-[#353535] mb-4">Tap the approximate direction.</p>
          
          <div className="flex justify-center mb-4">
            <div className="grid grid-cols-3 gap-3 p-6 bg-white rounded-xl border-2 border-gray-200">
              {gridDirections.map((row, rowIdx) => (
                row.map((dir, colIdx) => {
                  const cellId = dir.toLowerCase().replace(' ', '-');
                  const isSelected = pujaLocation === cellId;
                  
                  return (
                    <button
                      key={`${rowIdx}-${colIdx}`}
                      onClick={() => onLocationChange(cellId)}
                      disabled={dir === 'Center'}
                      className={`w-20 h-20 rounded-lg border-2 font-bold text-xs transition-all hover:scale-105 ${
                        isSelected
                          ? 'bg-[#232323] text-white border-[#232323]'
                          : 'bg-white text-[#232323] border-gray-300 hover:border-[#232323]'
                      } ${
                        dir === 'Center' ? 'opacity-50' : ''
                      }`}
                    >
                      <div className="flex flex-col items-center justify-center">
                        <Sparkles className="w-5 h-5 mb-1" />
                        <span>{dir}</span>
                      </div>
                    </button>
                  );
                })
              ))}
            </div>
          </div>

          <button
            onClick={() => onLocationChange('unsure')}
            className={`w-full p-3 border-2 rounded-lg text-center transition-all hover:shadow-md ${
              pujaLocation === 'unsure'
                ? 'border-[#232323] bg-[var(--accent-saffron)]'
                : 'border-gray-200 hover:border-[#999999]'
            }`}
          >
            <span className="font-semibold text-[#232323]">Not sure / No idea</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default PujaAreaStep;